import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import React, { useState } from "react";
import Lottie from "react-lottie";

import { lottieLoopOptions } from "../../../../utils/Utils";
import VerificationLayout from "../../../layout/VerificationLayout.component";
import mfaAnim from "../../../../assets/gifs/mfa.json";
import AppButton from "../../../base/AppButton.component";
import { Box } from "@mui/system";

const MFAOption = ({
  mfaSelectedHandler,
  setSelectedOption,
  options,
  selectedOption,
}) => {
  lottieLoopOptions.animationData = mfaAnim;
  const [disableButton, setDisableButton] = useState(false);

  return (
    <VerificationLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" align="center">
          Options to receive security code
        </Typography>
        <Lottie
          options={lottieLoopOptions}
          height={window.innerWidth <= 750 ? 180 : 220}
          width={window.innerWidth <= 750 ? 150 : 190}
        />
      </Box>

      <RadioGroup
        sx={{
          flex: 1,
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        onChange={(event) => {
          options.forEach((option) => {
            if (option.key === event.target.value) {
              setSelectedOption(option);
            }
          });
        }}
      >
        {options.map((option, index) => {
          return (
            <FormControlLabel
              value={option.key}
              control={<Radio />}
              label={option.value}
              key={index}
            />
          );
        })}
      </RadioGroup>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <AppButton
          sx={{ m:1 , width: "50%" }}
          loading={disableButton}
          clickHandler={(e) => {
            disableButton ? e.preventDefault() : mfaSelectedHandler();
            setDisableButton(true);
          }}
          buttonText="Submit"
          disabled={!selectedOption || disableButton}
        />
      </Box>
    </VerificationLayout>
  );
};

export default MFAOption;
